import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux'

import { security, userRoles } from '../features/security/thunks/securityThunk';
import { MedicalSpecialty } from '../defs/medicalSpecialty';
import { AnyAction, AsyncThunkAction, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../api/client';
import { AppDispatch } from '../app/store';

export const getSpecialtySecurity = createAsyncThunk(
    'security/getSpecialty',
    async (args: { token: string, username?: string }) => {
        const response = await client.post("security", { token: args.token, username: args.username }, 'getSpecialty');
        return response.data;
    }
);

export const useMedicalSpecialty = () => {
    const dispatch: AppDispatch = useDispatch();
    const credential = useSelector(security)?.credential;

    const [specialty, setSpecialty] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        if (!credential) return;

        dispatch(
            getSpecialtySecurity({
                token: credential.token,
                username: credential.username
            })
        )
            .unwrap()
            .then(response => {
                setSpecialty(response.specialtyFlags);
            });
    }, [credential, dispatch]);

    return {
        medicalSpecialty: specialty,
        isNone: specialty === MedicalSpecialty.None,
        isOdontoiatrica: specialty === MedicalSpecialty.Odontoiatrica || specialty === MedicalSpecialty.OdontoFisio,
        isFisio: specialty === MedicalSpecialty.Fisioterapica || specialty === MedicalSpecialty.OdontoFisio,
        isOdontoFisio: specialty === MedicalSpecialty.OdontoFisio,
        isAll: specialty === MedicalSpecialty.All
    };
};

